import { isTypeProcessStepsSection } from '@platform/contentful';
import { Entry } from 'contentful';
import ContentfulProcessStep from './ContentfulProcessStep';
import cx from 'classix';
import ContentfulTableOfContentsSetting from './ContentfulTableOfContentsSetting';
import BackToTopCta from './util/BackToTopCta';
import MarkdownText from './util/MarkdownText';
import { getFullWidthBackgroundStyles } from './util/utils';

const ContentfulProcessStepsSection = ({
  entry,
}: {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  entry: Entry<any, 'WITHOUT_UNRESOLVABLE_LINKS', 'en-US'> | undefined;
}) => {
  if (!entry || !isTypeProcessStepsSection(entry)) {
    return null;
  }

  return (
    <div className={cx('text-left flex flex-col', getFullWidthBackgroundStyles(entry))}>
      <div className='sm:max-w-[600px] sm:mx-auto my-3 sm:my-8'>
        <h2 className='text-2xl sm:text-3xl font-header font-semibold text-gray-500'>
          {entry.fields.header}
        </h2>
        <h3>{entry.fields.subHeader}</h3>
        <MarkdownText text={entry.fields.description} />
        <div className='flex flex-col gap-2'>
          {entry.fields.steps?.map((step, index) => (
            <ContentfulProcessStep
              key={step?.sys.id}
              entry={step}
              stepNumber={index + 1}
              isLastStep={index + 1 === entry.fields.steps.length}
            />
          ))}
        </div>
        <BackToTopCta enabled={entry.fields.backToTopCta} />
        <ContentfulTableOfContentsSetting entry={entry.fields.tocSetting} />
      </div>
    </div>
  );
};

export default ContentfulProcessStepsSection;
